export default "__VITE_ASSET__BEr$V5rS__"